// extracted by mini-css-extract-plugin
module.exports = {"section":"section--eleeFC4Q","sectionTitle":"sectionTitle--NlSCCssh","sectionContent":"sectionContent--Yo2A3RX5"};